/* eslint-disable no-promise-executor-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { call, delay, put, takeLatest } from 'redux-saga/effects';

import api from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import { getConfigStorageItem } from '../../hooks/useConfigStorage';
import { isJson } from '../../utils/dataTypes';
import {
 createClientConfigurationFailure,
 createClientConfigurationFinish,
 createClientConfigurationStart,
 createClientConfigurationSuccess,
 deleteClientConfigurationFailure,
 deleteClientConfigurationFinish,
 deleteClientConfigurationStart,
 deleteClientConfigurationSuccess,
 getClientConfigurationFailure,
 getClientConfigurationFinish,
 getClientConfigurationsFailure,
 getClientConfigurationsStart,
 getClientConfigurationsSuccess,
 getClientConfigurationStart,
 getClientConfigurationSuccess,
 getCurrentPresetFailure,
 getCurrentPresetStart,
 getCurrentPresetSuccess,
 updateClientConfigurationFailure,
 updateClientConfigurationFinish,
 updateClientConfigurationStart,
 updateClientConfigurationSuccess,
} from './clientConfigurationSlice';

const getConfigByName = (name: string, configurationObj: any) => {
 if (typeof configurationObj !== 'object' || configurationObj === null)
  return false;

 const confVal = configurationObj.find(
  (conf: any) => conf.Parameter === name,
 )?.Value;
 //  console.log({ confVal, a: JSON.parse(confVal), name, configurationObj });
 if (isJson(confVal)) {
  return JSON.parse(confVal);
 }
 return false;
};

function* getCurrentPreset(props: any) {
 const { type, table } = props.payload;
 console.log('getCurrentPreset', props.payload);
 try {
  const currentLSPreset = getConfigStorageItem(table)[type];
  //   console.log(type, table, currentLSPreset);
  yield put(
   getCurrentPresetSuccess({
    page: table,
    ...(type === 'columns' && { currentColumnsPreset: currentLSPreset }),
   }),
  );
 } catch (error: unknown) {
  yield* errorHandling(error, getCurrentPresetFailure);
 }
}

function* fetchClientConfiguration(props: any) {
 try {
  const response: AxiosResponse<any[]> = yield call(
   api.get,
   `/ClientConfiguration/v1/${props.payload}`,
  );
  yield put(
   getClientConfigurationSuccess({
    data: response.data || [],
    rowCount: response.headers['x-total-count'] || 123,
    message: 'ClientConfiguration loaded successfully',
    type: 'success',
   }),
  );
  yield delay(0); // ???
  yield put(getClientConfigurationFinish(null));
 } catch (error: unknown) {
  yield* errorHandling(error, getClientConfigurationFailure);
 }
}

function* fetchClientConfigurations(props: any) {
 try {
  const configurationObj = isJson(localStorage.getItem('configuration') || '')
   ? JSON.parse(localStorage.getItem('configuration') || '[]')
   : [];
  if (!props.payload.cached || configurationObj.length === 0) {
   //    console.log('[ == config loaded from API == ]');

   const response: AxiosResponse<any[]> = yield call(
    api.post,
    `/ClientConfiguration/v1`,
    {},
   );
   yield put(
    getClientConfigurationsSuccess({
     clientConfigurations: response.data || [],
     presetsColumns: getConfigByName('columns', response.data),
     fieldPresets: getConfigByName('fields', response.data),
     data: response.data || [],
     rowCount: response.headers['x-total-count'] || 123,
     message: 'ClientConfiguration loaded successfully',
     type: 'success',
    }),
   );
   localStorage.setItem('configuration', JSON.stringify(response.data));
  } else {
   console.log('[ == config loaded from LS == ]');
   yield put(
    getClientConfigurationsSuccess({
     clientConfigurations: configurationObj || [],
     presetsColumns: getConfigByName('columns', configurationObj),
     fieldPresets: 'pierdole',
     data: configurationObj || [],
     rowCount: configurationObj.length,
    }),
   );
  }
  //   yield delay(1); // ???
  //   yield put(getClientConfigurationsFinish(null));
 } catch (error: unknown) {
  console.log('######################', error);
  yield* errorHandling(error, getClientConfigurationsFailure);
 }
}
function* createClientConfiguration(props: any) {
 try {
  const response: AxiosResponse<any[]> = yield call(
   api.post,
   `/ClientConfiguration/v1/create`,
   props.payload.data,
  );

  yield put(
   createClientConfigurationSuccess({
    data: response.data,
    // rowCount: response.headers['x-total-count'] || 123,
   }),
  );
  yield delay(0); // ???
  yield put(createClientConfigurationFinish(null));
 } catch (error: unknown) {
  yield* errorHandling(error, createClientConfigurationFailure);
 }
}

function* updateClientConfiguration(props: any) {
 try {
  const response: AxiosResponse<any[]> = yield call(
   api.put,
   `/ClientConfiguration/v1/update/${props.payload.id}`,
   props.payload.data,
  );

  yield put(
   updateClientConfigurationSuccess({
    data: response.data,
    // rowCount: response.headers['x-total-count'] || 123,
   }),
  );
  yield delay(0); // ???
  yield put(updateClientConfigurationFinish(null));
 } catch (error: unknown) {
  yield* errorHandling(error, updateClientConfigurationFailure);
 }
}

function* deleteClientConfiguration(props: any) {
 try {
  const response: AxiosResponse<any[]> = yield call(
   api.del,
   `/ClientConfiguration/v1/delete/${props.payload.id}`,
   props.payload,
  );

  yield put(
   deleteClientConfigurationSuccess({
    data: response.data,
    // rowCount: response.headers['x-total-count'] || 123,
   }),
  );
  yield delay(0); // ???
  yield put(deleteClientConfigurationFinish(null));
 } catch (error: unknown) {
  yield* errorHandling(error, deleteClientConfigurationFailure);
 }
}

export default function* watchClientConfigurationSaga() {
 yield takeLatest(getCurrentPresetStart.type, getCurrentPreset);
 yield takeLatest(getClientConfigurationStart.type, fetchClientConfiguration);
 yield takeLatest(getClientConfigurationsStart.type, fetchClientConfigurations);
 yield takeLatest(
  createClientConfigurationStart.type,
  createClientConfiguration,
 );
 yield takeLatest(
  updateClientConfigurationStart.type,
  updateClientConfiguration,
 );
 yield takeLatest(
  deleteClientConfigurationStart.type,
  deleteClientConfiguration,
 );
}
